export default __webpack_public_path__ + "static/Logo-867b2a8a6504a2abc3aa5463ce6ebd06.png";